import { remove as removeCookie } from 'js-cookie'

import { credentialsCookie, persistedStateSlices } from '../config'
import { pick }                                    from '../utils/index'

export default function logout () {
  removeCookie(credentialsCookie.name)
  const storedStateString = window.localStorage.getItem('state')

  window.localStorage.removeItem('state')

  if (storedStateString !== null) {
    const storedState = JSON.parse(storedStateString)

    const stateToBePersisted = pick(storedState, persistedStateSlices)

    window.localStorage.setItem(
      'state',
      JSON.stringify(stateToBePersisted),
    )
  }

  window.location.reload()
}



// WEBPACK FOOTER //
// ./src/project-utils/hard-logout.ts